module.exports = __webpack_public_path__ + "static/media/b.97fe95b0.jpg";